
import React , { useState, useEffect }from 'react';
import SelectWithFetch from '../../common/selectWithFetch'
import { searchGlobalDiagnosis } from '../../../graphql/queries';
import { withApollo } from 'react-apollo';


const Diagnosis=(props)=>{
  // const context = useContext(CasesheetContext)
  const [selectExm,setselectExm] = useState(null);
  const [data,setdata] = useState([]);
  const [loading,setloading] = useState(false);

  useEffect(() => {
   if(props.form){
     let values = props.form.getFieldsValue();

    if(values.diagnosis && Array.isArray(values.diagnosis)){
      let arr = values.diagnosis.map((a)=>{
        if(!a){
          return
        }
        return {value: a.value, label: a.label, key: a.key}
      })
      setselectExm(arr)

    }
    if(values.diagnosis && !Array.isArray(values.diagnosis)){
      let obj = {value: values.value, label: values.label, key: values.key}
      setselectExm([obj])

    }
   }
  }, [])


const handleFetchData=(val)=>{
    setloading(true)
      props.client.query({
        query: searchGlobalDiagnosis,
        variables:{
          searchValue: val,
          from:0,
          size:100
        },
      }).then((data)=>{
       if(data.data.searchGlobalDiagnosis){
        setdata(data.data.searchGlobalDiagnosis)
       }
       setloading(false)
      }).catch((err)=>{
       console.log(err)
       setloading(false)
      })
}


    return(
        <div style={{width:'100%'}}>
              <SelectWithFetch
                type="multi"
                loading={loading}
                // size="large"
                placeholder="Type to Search Diagnosis"
                // selected={selectExm}
                custVal={selectExm != undefined && selectExm != null && Array.isArray(selectExm) ?
                  selectExm.map((a)=>{
                    return{
                    key: a.key,
                    value: a.value,
                    label: a.label
                  }})
                
                : null}
                dropDownEnabled={true}
                dropDownComp={<>
                
                </>}
                handleSearch={(val) => {
                  handleFetchData(val)
                }}
                data={data}
                keyName={'code'}
                fields={[
                  {
                    title: null,
                    val: 'code'
                  },{
                  title: null,
                  val: 'name'
                }]}
                setSelectedResult={(val) => {

                  if(val){
                    props.onChange(val)
                    setselectExm(val)
                    if(props.form){
     
                      props.form.setFieldsValue({
                        diagnosis: val
                      })
                    }
                  }else{
                    setselectExm(val)
                  }
                }}
            />

        </div>
    )
}

export default withApollo(Diagnosis)